/**
 * SAY MY NAME — whether the ORIGIN story page is open.
 *
 * ORIGIN is BRAND navigation, not a step of the naming process, so it is
 * deliberately NOT part of the agent conversation: opening it is a pure
 * client-side view switch that costs no turn, asks the model for nothing, and —
 * crucially — leaves the mounted surface untouched underneath. Closing it puts
 * the customer back on exactly the canvas they left, with their brief, findings
 * and candidates intact.
 *
 * That is why this is a client store and not an authored surface. In `site` mode
 * the latest surface IS the page, so routing ORIGIN through the agent would
 * replace the working canvas and returning would depend on the model rebuilding
 * the customer's work from scratch. A story page must never be able to cost
 * someone their session.
 *
 * Module-level observable, matching studio-state.ts: the header lives outside the
 * surface tree, so shared UI state lives beside it rather than in a surface prop.
 */
import { observable, runInAction } from 'mobx';

const originOpenBox = observable.box(false);

export function isOriginOpen(): boolean {
  return originOpenBox.get();
}

export function openOriginPage(): void {
  if (!originOpenBox.get()) {
    runInAction(() => originOpenBox.set(true));
  }
}

/** Back to the naming experience, exactly as it was left. */
export function closeOriginPage(): void {
  if (originOpenBox.get()) {
    runInAction(() => originOpenBox.set(false));
  }
}
